import { CheckCircle, XCircle } from "@phosphor-icons/react";

export default function CarbonSubmissionsTab({ submissions, onVerify }) {
  return (
    <div className="space-y-4" data-testid="admin-carbon-tab">
      <div>
        <h2 className="font-heading text-xl font-semibold mb-1">Carbon Credit Submissions</h2>
        <p className="text-xs text-stone-500 font-body">
          Review and verify carbon credit claims. Verified submissions are based on satellite-confirmed
          tree coverage and CO2 absorption calculations (22kg CO2/tree/year at $15/ton).
        </p>
      </div>
      {submissions.length === 0 ? (
        <p className="text-stone-500 text-center py-12">No submissions yet</p>
      ) : submissions.map((s, i) => (
        <div key={i} className="bg-stone-900 rounded-xl border border-stone-800 p-4 flex items-center gap-4"
             data-testid={`carbon-sub-${i}`}>
          <div className="flex-1 grid grid-cols-2 md:grid-cols-5 gap-3">
            <div><p className="text-[10px] text-stone-500">Location</p><p className="text-sm">{s.lat?.toFixed(4)}, {s.lon?.toFixed(4)}</p></div>
            <div><p className="text-[10px] text-stone-500">Area</p><p className="text-sm">{s.area_km2} km²</p></div>
            <div><p className="text-[10px] text-stone-500">Trees</p><p className="text-sm text-emerald-400">{s.estimated_trees?.toLocaleString()}</p></div>
            <div><p className="text-[10px] text-stone-500">CO2 (tons/yr)</p><p className="text-sm">{s.co2_tons}</p></div>
            <div><p className="text-[10px] text-stone-500">Value</p><p className="text-sm text-amber-400">${s.value_usd?.toLocaleString()}</p></div>
          </div>
          <div className={`text-xs px-3 py-1 rounded-full font-medium ${
            s.status === "verified" ? "bg-emerald-600/20 text-emerald-400" :
            s.status === "rejected" ? "bg-red-600/20 text-red-400" :
            "bg-amber-600/20 text-amber-400"
          }`}>{s.status}</div>
          {s.status === "pending_verification" && (
            <div className="flex gap-2">
              <button onClick={() => onVerify(s.id || i, "verify")}
                className="bg-emerald-600 hover:bg-emerald-700 text-white text-xs px-3 py-1.5 rounded-lg flex items-center gap-1"
                data-testid={`verify-btn-${i}`}>
                <CheckCircle size={14} /> Verify
              </button>
              <button onClick={() => onVerify(s.id || i, "reject")}
                className="bg-red-600/20 hover:bg-red-600/30 text-red-400 text-xs px-3 py-1.5 rounded-lg flex items-center gap-1"
                data-testid={`reject-btn-${i}`}>
                <XCircle size={14} /> Reject
              </button>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
